import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import { createEpicMiddleware } from 'redux-observable';
import { BehaviorSubject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { GlobalMessage, appApi, appApiRejectionsLoggerMiddleware } from '@alycecom/services';
import { configureStore as rjsConfigureStore } from '@reduxjs/toolkit';
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';

import { analyticService } from '../services/analytics.service';
import { apiService } from '../services/api.service';
import { appApiRedirectMiddleware } from '../middlewares/appApiRedirectMiddleware';

import { rootEpic, rootReducer } from './root';

export const history = createBrowserHistory();

const epicMiddleware = createEpicMiddleware({
  dependencies: {
    apiService,
    analyticService,
    messagesService: GlobalMessage.messagesService,
  },
});

const middlewares = [
  routerMiddleware(history),
  epicMiddleware,
  appApi.middleware,
  appApiRejectionsLoggerMiddleware,
  appApiRedirectMiddleware,
];

const epic$ = new BehaviorSubject(rootEpic);

const hotReloadingEpic = (...args) => epic$.pipe(switchMap(epic => epic(...args)));

export const configureStore = () => {
  const store = rjsConfigureStore({
    reducer: rootReducer(history),
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }).concat(middlewares),
    devTools: true,
  });

  epicMiddleware.run(hotReloadingEpic);

  if (module.hot) {
    module.hot.accept('./root', () => {
      store.replaceReducer(rootReducer(history));
      epic$.next(rootEpic);
    });
  }

  return store;
};
